import { defineMessages } from "react-intl"

export const paymentStatusesMessages = defineMessages({
    //Payins
    paymentTitle: {
        id: "payment_processing.components.payment_statuses_messages.payments_title",
        defaultMessage: "Payments"
    },

    processingStatus: {
        id: "payment_processing.components.payment_statuses_messages.processing_status",
        defaultMessage: "Processing"
    },
    processingDescription: {
        id: "payment_processing.components.payment_statuses_messages.processing_description",
        defaultMessage: "The payment is currently being verified. "
        + "The funds are not yet available for upcoming payouts until it is authorized."
    },

    successStatus: {
        id: "payment_processing.components.payment_statuses_messages.success_status",
        defaultMessage: "Succeeded"
    },
    successDescription: {
        id: "payment_processing.components.payment_statuses_messages.success_description",
        defaultMessage: "The payment has been processed and the funds are available for upcoming payouts."
    },

    failedStatus: {
        id: "payment_processing.components.payment_statuses_messages.failed_status",
        defaultMessage: "Failed"
    },
    failedDescription: {
        id: "payment_processing.components.payment_statuses_messages.failed_description",
        defaultMessage: "The payment unsuccessfully attempted to process."
    },

    canceledStatus: {
        id: "payment_processing.components.payment_statuses_messages.canceled_status",
        defaultMessage: "Canceled"
    },
    canceledDescription: {
        id: "payment_processing.components.payment_statuses_messages.canceled_description",
        defaultMessage: "The payment is canceled before it has completed processing."
    },

    //Refunds
    refundTitle: {
        id: "payment_processing.components.payment_statuses_messages.refunds_title",
        defaultMessage: "Refunds"
    },
    refundProcessingDescription: {
        id: "payment_processing.components.payment_statuses_messages.refund_processing_description",
        defaultMessage: "The refund have been approved by the merchant and is currently being processed."
    },
    refundSuccessDescription: {
        id: "payment_processing.components.payment_statuses_messages.refund_success_description",
        defaultMessage: "The refund have been successfully processed and the funds transferred back to the customer."
    },
    refundFailedDescription: {
        id: "payment_processing.components.payment_statuses_messages.refund_failed_description",
        defaultMessage: "The refund unsuccessfully attempted to process."
    },
    refundCanceledDescription: {
        id: "payment_processing.components.payment_statuses_messages.refund_canceled_description",
        defaultMessage: "The refund is canceled before it has completed processing."
    },

    close: {
        id: "payment_processing.components.payment_statuses_messages.close",
        defaultMessage: "Close"
    },

    modalTitle: {
        id: "payment_processing.components.payment_statuses_messages.modal_title",
        defaultMessage: "What does the payment status mean?"
    },


})


// WEBPACK FOOTER //
// ./src/payment-processing/modals/PaymentStatusesMessages.ts